/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-south-1",
    "aws_cloud_logic_custom": [
        {
            "name": "geo",
            "endpoint": "https://vhm0jvfuzf.execute-api.eu-south-1.amazonaws.com/dev",
            "region": "eu-south-1"
        },
        {
            "name": "users",
            "endpoint": "https://j29l726ux0.execute-api.eu-south-1.amazonaws.com/dev",
            "region": "eu-south-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://aktq3nscunhpph5rrxl666h4ia.appsync-api.eu-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-south-1:846a0c09-05d2-4002-a7bd-a49b8b6d3983",
    "aws_cognito_region": "eu-south-1",
    "aws_user_pools_id": "eu-south-1_R7cTRXjzs",
    "aws_user_pools_web_client_id": "494pcn8jvbkrt6eqg76auqci10",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
